"use strict";
'use es6';

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _Routes = _interopRequireDefault(require("./Routes"));

var _reducers = _interopRequireDefault(require("./reducers"));

var _epics = _interopRequireDefault(require("./epics"));

var _default = {
  reducer: _reducers.default,
  route: 'workspaces',
  routes: _Routes.default,
  dsn: 'https://ad73804f03584af490059548b7fa9973@exceptions.hubspot.com/431678',
  newRelicAppId: '101323408',
  shouldModuleRender: function shouldModuleRender(_ref) {
    var scopes = _ref.scopes;
    return scopes.includes('workspaces-read');
  },
  rootEpic: _epics.default
};
exports.default = _default;
module.exports = exports.default;